<template>
  <div>
    <Spinner />
  </div>
</template>

<script>
import Spinner from "../components/Widgets/Spinner.vue";
import TranslationHelper from "../helpers/translation";

export default {
  name: "TranslationReset",
  components: { Spinner },
  async created() {
    const locale = localStorage.getItem("locale") || "en";
    try {
      await TranslationHelper.updateTranslations(this.$router, locale, true);
      this.$toastr.s("Success", this.$t("listing.translationResetSuccess"));
    } catch {
      this.$toastr.e("Error", this.$t("reservation.translationResetError"));
    } finally {
      this.$router.push("/");
    }
  },
};
</script>

<style scoped></style>
